import { useMemo, FC } from 'react'
import { useTranslation } from 'next-i18next'
import { AddressCard } from '../AddressCard/AddressCard'
import { Maybe, CustomerAddress } from '@pylot-data/fwrdschema'
import s from '@pagestyles/Account.module.scss'

type Props = {
    addresses: Maybe<CustomerAddress>[]
    countryNameLocale: Record<string, any>
}

const DEFAULT_SHIPPING_LABEL = 'Default Shipping Address'
const DEFAULT_BILLING_LABEL = 'Default Billing Address'
const CHANGE_SHIPPING_LABEL = 'Change Shipping Address'
const CHANGE_BILLING_LABEL = 'Change Billing Address'

export const DefaultAddress: FC<Props> = ({ addresses, countryNameLocale }) => {
    const { t } = useTranslation(['account'])

    const defaultAddresses = useMemo(() => {
        const [defaultShipping] = addresses.filter((address) => {
            return address?.default_shipping
        })
        const [defaultBilling] = addresses.filter((address) => {
            return address?.default_billing
        })

        const getDefaultBilling = () => {
            if (defaultBilling) {
                return (
                    <AddressCard
                        address={defaultBilling!}
                        countryName={countryNameLocale.get(
                            defaultBilling?.country_code
                        )}
                        changeAddressLabel={CHANGE_BILLING_LABEL}
                    />
                )
            }
            return t('account||account|No default addresses')
        }

        const getDefaultShipping = () => {
            if (defaultShipping) {
                return (
                    <AddressCard
                        address={defaultShipping!}
                        countryName={countryNameLocale.get(
                            defaultShipping?.country_code
                        )}
                        changeAddressLabel={CHANGE_SHIPPING_LABEL}
                    />
                )
            }
            return t('account||account|No default addresses')
        }

        return (
            <>
                <div>
                    <h2 className="box-info-title">
                        {t(`account||account|${DEFAULT_BILLING_LABEL}`)}
                    </h2>
                    {getDefaultBilling()}
                </div>
                <div>
                    <h2 className="box-info-title">
                        {t(`account||account|${DEFAULT_SHIPPING_LABEL}`)}
                    </h2>
                    {getDefaultShipping()}
                </div>
            </>
        )
    }, [addresses, countryNameLocale, t])

    return (
        <div className={s['account-container']}>
            <div className={s['account-block-grid']}>{defaultAddresses}</div>
        </div>
    )
}
